import type { IconData } from '@stacksjs/iconify-core'

export const businessProductsBag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.715 8.38h1.52v6.1h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm-1.52 21.33h1.52v1.53h-1.52Zm0-12.19h1.52v12.19h1.53V14.48h-3.05zm-3.05 0h3.05v1.53h-3.05ZM5.335 29.72h21.33v1.52H5.335Zm15.24-12.19h3.04v1.52h-3.04Zm-6.1 3.04v3.05h3.05v-3.05h3.05v-1.52h-3.05v-1.52h-3.05v1.52h-3.05v1.52zM8.375.76h15.24v1.53H8.375Z\"/><path fill=\"currentColor\" d=\"M8.375 17.53h3.05v1.52h-3.05ZM5.335 16h3.04v1.53h-3.04Zm22.85-9.14V5.34h-3.04V2.29h-1.53v3.05H8.375V2.29h-1.52v3.05h-3.05v1.52zM3.805 28.19h1.53v1.53h-1.53Zm0-12.19h1.53v-1.52h-3.05v13.71h1.52zm-1.52-9.14h1.52v1.52h-1.52ZM.765 8.38h1.52v6.1H.765Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default businessProductsBag
